import type { ActionSource } from "~/actions/types";

export interface AnalyticsEvent {
  event: string;
  name: string;
  properties: Record<string, unknown>;
}

/**
 * Deliberately not a vendor SDK (§15). It exists so the *shape* of the data is right from
 * day one: which capability was invoked, and from which surface.
 */
class Analytics {
  private readonly buffer: AnalyticsEvent[] = [];
  private sink: ((event: AnalyticsEvent) => void) | null = null;

  track(event: string, name: string, properties: Record<string, unknown> = {}): void {
    const payload: AnalyticsEvent = { event, name, properties };
    this.buffer.push(payload);
    if (this.buffer.length > 100) {
      this.buffer.shift();
    }
    this.sink?.(payload);
  }

  trackAction(name: string, source: ActionSource): void {
    this.track("perform_action", name, { source });
  }

  /** SLATE-LATER: point this at a real provider. */
  setSink(sink: ((event: AnalyticsEvent) => void) | null): void {
    this.sink = sink;
  }

  recent(): readonly AnalyticsEvent[] {
    return this.buffer;
  }

  reset(): void {
    this.buffer.length = 0;
  }
}

export const analytics = new Analytics();
